import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../../layouts/dashboard/default"));
const AllPriorities = lazy(() => import("../pages/all-priorities"));

export const PriorityRouter = [
  {
    path: "/master-management/priority",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "all",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllPriorities />
          </Suspense>
        ),
      },
    ],
  },
];
